const ptBR = {
  metaTitle: 'Automação com IA | WSJ Soluções Digitais',
  badge: 'Automação com IA',
  heroTitle: 'Automação inteligente com IA para empresas modernas.',
  heroSubtitle:
    'A WSJ cria robôs automatizados, assistentes inteligentes e fluxos com inteligência artificial para reduzir trabalho manual e melhorar o atendimento.',
  heroBadges: [
    'ChatGPT',
    'Inteligência Artificial',
    'WhatsApp Bot',
    'Automação por voz',
    'APIs',
    'Atendimento inteligente',
    'Fluxos automatizados',
    'IA integrada'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnPlans: 'Ver soluções',
  whatsappMessage: 'Olá! Gostaria de um orçamento para automação com IA com a WSJ.',

  sectionProblemsTitle: 'Problemas que a automação inteligente ajuda a resolver',
  sectionProblemsClose:
    'A automação não substitui pessoas. Ela reduz tarefas repetitivas e melhora a operação.',
  problemItems: [
    { title: 'Atendimento repetitivo', desc: 'Perguntas frequentes que consomem tempo da equipe todos os dias.' },
    { title: 'Demora nas respostas', desc: 'Clientes esperando retorno enquanto a operação não acompanha o volume.' },
    { title: 'Equipe sobrecarregada', desc: 'Colaboradores presos em tarefas manuais em vez de foco estratégico.' },
    { title: 'Clientes sem resposta', desc: 'Mensagens perdidas, filas longas e experiência inconsistente.' },
    { title: 'Falta de organização', desc: 'Informações espalhadas sem fluxo claro de atendimento ou registro.' },
    { title: 'Horário limitado de atendimento', desc: 'Operação presa ao horário comercial enquanto clientes buscam respostas 24h.' },
    { title: 'Processos manuais', desc: 'Pedidos, agendamentos e follow-ups feitos um a um, sem escala.' },
    { title: 'Perda de oportunidades', desc: 'Leads e vendas que esfriam por falta de resposta rápida e inteligente.' }
  ],

  sectionSolutionsTitle: 'Soluções de automação com inteligência artificial',
  sectionSolutionsLead: 'Da primeira automação à operação inteligente completa — estruturamos conforme seu negócio.',
  solutions: [
    { title: 'Bot para WhatsApp', desc: 'Atendimento automatizado no canal que seus clientes já usam.' },
    { title: 'IA integrada ao ChatGPT', desc: 'Respostas inteligentes conectadas a modelos avançados de linguagem.' },
    { title: 'Atendimento automático', desc: 'Fluxos que respondem, qualificam e encaminham conforme regras.' },
    { title: 'Fluxos inteligentes', desc: 'Jornadas automatizadas com decisões baseadas em contexto.' },
    { title: 'Automação por voz', desc: 'Assistentes de voz para atendimento, triagem e operação.' },
    { title: 'IA para agendamento', desc: 'Confirmações, lembretes e gestão de horários automatizados.' },
    { title: 'IA para vendas', desc: 'Qualificação de leads, catálogo e condução comercial inteligente.' },
    { title: 'IA para suporte', desc: 'Resolução de dúvidas, status e encaminhamento técnico.' },
    { title: 'Integração com sistemas', desc: 'Conexão com ERP, CRM, painéis e ferramentas existentes.' },
    { title: 'APIs e webhooks', desc: 'Comunicação em tempo real entre sistemas e automações.' },
    { title: 'Dashboard administrativo', desc: 'Painel para acompanhar conversas, fluxos e operação.' },
    { title: 'IA personalizada', desc: 'Assistente treinado com contexto, regras e tom do seu negócio.' }
  ],

  sectionWhatsappTitle: 'WhatsApp inteligente para atendimento e operação',
  sectionWhatsappLead:
    'Automatizamos atendimento, captação e operação no WhatsApp com fluxos inteligentes e IA integrada — sempre alinhados à realidade do seu negócio.',
  whatsappFeatures: [
    'Respostas automáticas',
    'Fluxos de atendimento',
    'IA integrada',
    'Captação de leads',
    'Pedidos',
    'Agendamentos',
    'Catálogo',
    'Encaminhamento inteligente',
    'Atendimento híbrido humano + IA'
  ],
  whatsappNote:
    'A integração com WhatsApp pode depender de APIs oficiais, provedores externos e políticas da Meta.',

  sectionAiTitle: 'IA conectada ao seu negócio',
  sectionAiLead:
    'Integramos inteligência artificial ao contexto da sua empresa — com respostas relevantes, fluxos personalizados e conexão com seus sistemas.',
  aiFeatures: [
    'Integração com ChatGPT',
    'Assistente treinado com contexto do negócio',
    'IA por texto',
    'IA por voz',
    'Automação inteligente',
    'Respostas contextualizadas',
    'Fluxos personalizados',
    'Integração com banco de dados',
    'Histórico de atendimento',
    'IA conectada a APIs'
  ],
  aiNote:
    'Serviços de inteligência artificial podem gerar consumo mensal baseado em utilização, tokens, chamadas de API e ferramentas externas.',

  sectionCostsTitle: 'Automação com IA envolve infraestrutura e serviços externos',
  sectionCostsLead:
    'A WSJ trabalha com transparência para o cliente entender os custos reais de operação antes do projeto iniciar.',
  sectionCostsIntro:
    'Automações com IA não são ilimitadas por padrão. APIs de inteligência artificial, WhatsApp, servidores, bancos de dados, voz e integrações externas podem gerar custos mensais conforme o volume e a complexidade do projeto.',
  costItems: [
    { title: 'OpenAI / ChatGPT API', desc: 'Consumo baseado em tokens, modelos utilizados e volume de interações.' },
    { title: 'WhatsApp API', desc: 'Custos conforme provedor, volume de mensagens e políticas da Meta.' },
    { title: 'Servidores', desc: 'Hospedagem, processamento e infraestrutura para fluxos e integrações.' },
    { title: 'Banco de dados', desc: 'Armazenamento de histórico, contexto, pedidos e registros operacionais.' },
    { title: 'Voz IA', desc: 'Síntese, transcrição e serviços de voz podem gerar consumo adicional.' },
    { title: 'Integrações externas', desc: 'Ferramentas pagas de terceiros conectadas à automação.' }
  ],
  costsHighlight:
    'A WSJ trabalha com transparência para o cliente entender os custos reais de operação antes do projeto iniciar.',

  sectionProcessTitle: 'Como funciona o processo',
  sectionProcessLead: 'Um caminho claro da ideia à operação inteligente — com transparência em cada etapa.',
  processSteps: [
    { title: 'Entendemos o fluxo do negócio', desc: 'Mapeamos atendimento, processos, canais e objetivos reais.' },
    { title: 'Definimos automações e integrações', desc: 'Escopo, APIs, IA, custos externos e arquitetura da solução.' },
    { title: 'Criamos os fluxos inteligentes', desc: 'Bots, jornadas, regras e experiência de atendimento.' },
    { title: 'Integramos IA e APIs', desc: 'ChatGPT, WhatsApp, sistemas internos e ferramentas externas.' },
    { title: 'Testamos e acompanhamos a operação', desc: 'Validação, ajustes e suporte conforme plano contratado.' }
  ],

  sectionPlansTitle: 'Planos de automação com inteligência artificial',
  sectionPlansLead: 'Do primeiro bot à operação inteligente completa — estrutura profissional com transparência.',
  plansBillingMonthly: 'Mensal',
  plansBillingAnnual: 'Anual',
  plansSaveBadge: 'Economize 17%',
  plansDisclaimer:
    'Os valores não incluem consumo de APIs, OpenAI, WhatsApp API, servidores, ferramentas externas, storage, integrações pagas ou custos cobrados por terceiros.',
  plansDisclaimerExtra:
    'Projetos com IA avançada, voz, alto volume de mensagens, múltiplos canais, integrações complexas ou automações personalizadas exigem análise técnica e orçamento específico.',
  planStartName: 'AI Start',
  planStartDesc: 'Ideal para pequenas automações e atendimento inteligente inicial.',
  planStartFeatures: [
    'Bot inicial',
    'Fluxo automatizado',
    'Integração básica com IA',
    'WhatsApp automatizado básico',
    'Respostas automáticas',
    'Dashboard simples',
    'Suporte básico'
  ],
  planStartCta: 'Começar automação',
  planGrowthName: 'AI Growth',
  planGrowthBadge: 'Mais popular',
  planGrowthDesc: 'Ideal para empresas que querem automação mais inteligente e integrada.',
  planGrowthFeatures: [
    'Tudo do Start',
    'IA integrada ao ChatGPT',
    'Fluxos avançados',
    'Atendimento inteligente',
    'APIs',
    'Dashboard administrativo',
    'Histórico de atendimentos',
    'IA contextualizada',
    'Integrações externas',
    'Suporte prioritário'
  ],
  planGrowthCta: 'Começar agora',
  planPremiumName: 'AI Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc:
    'Ideal para operações mais complexas com IA, voz, múltiplos fluxos e integrações avançadas.',
  planPremiumFeatures: [
    'IA personalizada',
    'Fluxos avançados',
    'Automação por voz',
    'Integrações complexas',
    'APIs avançadas',
    'Arquitetura escalável',
    'Dashboard completo',
    'Consultoria técnica',
    'Atendimento dedicado',
    'SLA prioritário'
  ],
  planPremiumCta: 'Falar com especialista',

  sectionRealProjectsTitle: 'Experiência aplicada em soluções digitais reais',
  sectionRealProjectsLead:
    'A WSJ já desenvolve soluções digitais e integrações utilizadas em projetos reais.',
  realProjectsNote:
    'A experiência da WSJ em sistemas, e-commerce e automação permite criar fluxos inteligentes integrados à operação do cliente.',
  realProjectsVisitCta: 'Conhecer projeto',
  realProjectBadgeInstitutional: 'Institucional',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjectBadgeProduct: 'Produto WSJ',
  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Automação & pedidos',
      badge: 'product',
      desc: 'Plataforma de pedidos e atendimento digital desenvolvida pela WSJ para operações reais.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-violet-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Projeto digital profissional com foco em autoridade, branding e operação online.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com catálogo, experiência do usuário e profissionalismo.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de investir em automação com inteligência artificial.',
  faqItems: [
    {
      q: 'A IA usa ChatGPT?',
      a: 'Sim. Dependendo do projeto, integramos modelos da OpenAI (ChatGPT) e outras APIs de IA, sempre conforme escopo e proposta.'
    },
    {
      q: 'Existe custo mensal da OpenAI?',
      a: 'Sim. Serviços de IA como OpenAI possuem consumo baseado em utilização, tokens e chamadas de API. Esses custos não estão incluídos nos planos, salvo quando indicado em proposta.'
    },
    {
      q: 'O WhatsApp automatizado é oficial?',
      a: 'Depende da arquitetura do projeto. A integração pode utilizar APIs oficiais ou provedores externos, conforme necessidade, volume e políticas da Meta.'
    },
    {
      q: 'Vocês criam automação por voz?',
      a: 'Sim. Desenvolvemos assistentes de voz e automações por áudio, especialmente em planos avançados ou projetos personalizados.'
    },
    {
      q: 'A IA pode responder clientes automaticamente?',
      a: 'Sim. Criamos fluxos que respondem, qualificam, registram e encaminham clientes — com opção de atendimento híbrido humano + IA.'
    },
    {
      q: 'A automação funciona 24h?',
      a: 'Sim. Bots e fluxos automatizados podem operar continuamente, respeitando regras, limites de API e configurações do projeto.'
    },
    {
      q: 'Posso integrar com meu sistema?',
      a: 'Sim. Integramos com ERPs, CRMs, painéis, bancos de dados, APIs e webhooks conforme escopo técnico definido.'
    },
    {
      q: 'Existe limite de utilização?',
      a: 'Sim. Limites dependem do plano, arquitetura e consumo de APIs externas. Projetos de alto volume exigem análise técnica e orçamento específico.'
    },
    {
      q: 'Vocês oferecem suporte contínuo?',
      a: 'Sim. Oferecemos suporte, ajustes e evolução conforme plano contratado, incluindo acompanhamento da operação.'
    }
  ],

  finalCtaTitle: 'Pronto para automatizar sua operação com inteligência artificial?',
  finalCtaSubtitle:
    'A WSJ cria soluções inteligentes para empresas que querem reduzir trabalho manual e melhorar atendimento, organização e escala.',

  heroMock: {
    chatLabel: 'Chat IA',
    whatsappLabel: 'WhatsApp Bot',
    voiceLabel: 'Voz IA',
    analyticsLabel: 'Analytics',
    flowLabel: 'Fluxo automatizado',
    live: 'Operação ativa'
  }
};

const ptPT = {
  ...ptBR,
  metaTitle: 'Automatização com IA | WSJ Soluções Digitais',
  badge: 'Automatização com IA',
  heroTitle: 'Automatização inteligente com IA para empresas modernas.',
  heroSubtitle:
    'A WSJ cria robôs automatizados, assistentes inteligentes e fluxos com inteligência artificial para reduzir trabalho manual e melhorar o atendimento.',
  heroBadges: [
    'ChatGPT',
    'Inteligência Artificial',
    'WhatsApp Bot',
    'Automatização por voz',
    'APIs',
    'Atendimento inteligente',
    'Fluxos automatizados',
    'IA integrada'
  ],
  btnQuote: 'Solicitar orçamento',
  btnWhatsapp: 'Falar no WhatsApp',
  btnPlans: 'Ver soluções',
  whatsappMessage: 'Olá! Gostaria de um orçamento para automatização com IA com a WSJ.',

  sectionProblemsTitle: 'Problemas que a automatização inteligente ajuda a resolver',
  sectionProblemsClose:
    'A automatização não substitui pessoas. Reduz tarefas repetitivas e melhora a operação.',
  problemItems: [
    { title: 'Atendimento repetitivo', desc: 'Perguntas frequentes que consomem tempo da equipa todos os dias.' },
    { title: 'Demora nas respostas', desc: 'Clientes à espera enquanto a operação não acompanha o volume.' },
    { title: 'Equipa sobrecarregada', desc: 'Colaboradores presos a tarefas manuais em vez de foco estratégico.' },
    { title: 'Clientes sem resposta', desc: 'Mensagens perdidas, filas longas e experiência inconsistente.' },
    { title: 'Falta de organização', desc: 'Informações dispersas sem fluxo claro de atendimento ou registo.' },
    { title: 'Horário limitado de atendimento', desc: 'Operação presa ao horário comercial enquanto clientes procuram respostas 24h.' },
    { title: 'Processos manuais', desc: 'Pedidos, agendamentos e follow-ups feitos um a um, sem escala.' },
    { title: 'Perda de oportunidades', desc: 'Leads e vendas que esfriam por falta de resposta rápida e inteligente.' }
  ],

  sectionSolutionsTitle: 'Soluções de automatização com inteligência artificial',
  sectionSolutionsLead: 'Da primeira automatização à operação inteligente completa — estruturamos conforme o seu negócio.',
  solutions: [
    { title: 'Bot para WhatsApp', desc: 'Atendimento automatizado no canal que os seus clientes já usam.' },
    { title: 'IA integrada ao ChatGPT', desc: 'Respostas inteligentes ligadas a modelos avançados de linguagem.' },
    { title: 'Atendimento automático', desc: 'Fluxos que respondem, qualificam e encaminham conforme regras.' },
    { title: 'Fluxos inteligentes', desc: 'Jornadas automatizadas com decisões baseadas em contexto.' },
    { title: 'Automatização por voz', desc: 'Assistentes de voz para atendimento, triagem e operação.' },
    { title: 'IA para agendamento', desc: 'Confirmações, lembretes e gestão de horários automatizados.' },
    { title: 'IA para vendas', desc: 'Qualificação de leads, catálogo e condução comercial inteligente.' },
    { title: 'IA para suporte', desc: 'Resolução de dúvidas, estado e encaminhamento técnico.' },
    { title: 'Integração com sistemas', desc: 'Ligação a ERP, CRM, painéis e ferramentas existentes.' },
    { title: 'APIs e webhooks', desc: 'Comunicação em tempo real entre sistemas e automatizações.' },
    { title: 'Dashboard administrativo', desc: 'Painel para acompanhar conversas, fluxos e operação.' },
    { title: 'IA personalizada', desc: 'Assistente treinado com contexto, regras e tom do seu negócio.' }
  ],

  sectionWhatsappTitle: 'WhatsApp inteligente para atendimento e operação',
  sectionWhatsappLead:
    'Automatizamos atendimento, captação e operação no WhatsApp com fluxos inteligentes e IA integrada — sempre alinhados à realidade do seu negócio.',
  whatsappNote:
    'A integração com WhatsApp pode depender de APIs oficiais, fornecedores externos e políticas da Meta.',

  sectionAiTitle: 'IA ligada ao seu negócio',
  sectionAiLead:
    'Integramos inteligência artificial ao contexto da sua empresa — com respostas relevantes, fluxos personalizados e ligação aos seus sistemas.',
  aiFeatures: [
    'Integração com ChatGPT',
    'Assistente treinado com contexto do negócio',
    'IA por texto',
    'IA por voz',
    'Automatização inteligente',
    'Respostas contextualizadas',
    'Fluxos personalizados',
    'Integração com base de dados',
    'Histórico de atendimento',
    'IA ligada a APIs'
  ],
  aiNote:
    'Serviços de inteligência artificial podem gerar consumo mensal baseado em utilização, tokens, chamadas de API e ferramentas externas.',

  sectionCostsTitle: 'Automatização com IA envolve infraestrutura e serviços externos',
  sectionCostsIntro:
    'Automatizações com IA não são ilimitadas por defeito. APIs de inteligência artificial, WhatsApp, servidores, bases de dados, voz e integrações externas podem gerar custos mensais conforme o volume e a complexidade do projeto.',
  costItems: [
    { title: 'OpenAI / ChatGPT API', desc: 'Consumo baseado em tokens, modelos utilizados e volume de interações.' },
    { title: 'WhatsApp API', desc: 'Custos conforme fornecedor, volume de mensagens e políticas da Meta.' },
    { title: 'Servidores', desc: 'Alojamento, processamento e infraestrutura para fluxos e integrações.' },
    { title: 'Base de dados', desc: 'Armazenamento de histórico, contexto, pedidos e registos operacionais.' },
    { title: 'Voz IA', desc: 'Síntese, transcrição e serviços de voz podem gerar consumo adicional.' },
    { title: 'Integrações externas', desc: 'Ferramentas pagas de terceiros ligadas à automatização.' }
  ],

  sectionProcessTitle: 'Como funciona o processo',
  processSteps: [
    { title: 'Compreendemos o fluxo do negócio', desc: 'Mapeamos atendimento, processos, canais e objetivos reais.' },
    { title: 'Definimos automatizações e integrações', desc: 'Âmbito, APIs, IA, custos externos e arquitetura da solução.' },
    { title: 'Criamos os fluxos inteligentes', desc: 'Bots, jornadas, regras e experiência de atendimento.' },
    { title: 'Integramos IA e APIs', desc: 'ChatGPT, WhatsApp, sistemas internos e ferramentas externas.' },
    { title: 'Testamos e acompanhamos a operação', desc: 'Validação, ajustes e suporte conforme plano contratado.' }
  ],

  sectionPlansTitle: 'Planos de automatização com inteligência artificial',
  plansDisclaimerExtra:
    'Projetos com IA avançada, voz, alto volume de mensagens, múltiplos canais, integrações complexas ou automatizações personalizadas exigem análise técnica e orçamento específico.',
  planStartDesc: 'Ideal para pequenas automatizações e atendimento inteligente inicial.',
  planStartCta: 'Começar automatização',
  planGrowthDesc: 'Ideal para empresas que querem automatização mais inteligente e integrada.',
  planPremiumDesc:
    'Ideal para operações mais complexas com IA, voz, múltiplos fluxos e integrações avançadas.',

  realProjectsNote:
    'A experiência da WSJ em sistemas, e-commerce e automatização permite criar fluxos inteligentes integrados à operação do cliente.',
  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Automatização & pedidos',
      badge: 'product',
      desc: 'Plataforma de pedidos e atendimento digital desenvolvida pela WSJ para operações reais.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-violet-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Presença digital',
      badge: 'institutional',
      desc: 'Projeto digital profissional com foco em autoridade, branding e operação online.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Operação digital',
      badge: 'ecommerce',
      desc: 'Estrutura digital completa com catálogo, experiência do utilizador e profissionalismo.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Branding digital',
      badge: 'ecommerce',
      desc: 'Presença digital moderna com identidade visual premium e navegação profissional.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'Perguntas frequentes',
  sectionFaqLead: 'Transparência total antes de investir em automatização com inteligência artificial.',
  faqItems: [
    { q: 'A IA usa ChatGPT?', a: 'Sim. Conforme o projeto, integramos modelos da OpenAI (ChatGPT) e outras APIs de IA, sempre conforme âmbito e proposta.' },
    { q: 'Existe custo mensal da OpenAI?', a: 'Sim. Serviços de IA como OpenAI possuem consumo baseado em utilização, tokens e chamadas de API. Esses custos não estão incluídos nos planos, salvo quando indicado em proposta.' },
    { q: 'O WhatsApp automatizado é oficial?', a: 'Depende da arquitetura do projeto. A integração pode utilizar APIs oficiais ou fornecedores externos, conforme necessidade, volume e políticas da Meta.' },
    { q: 'Criam automatização por voz?', a: 'Sim. Desenvolvemos assistentes de voz e automatizações por áudio, especialmente em planos avançados ou projetos personalizados.' },
    { q: 'A IA pode responder clientes automaticamente?', a: 'Sim. Criamos fluxos que respondem, qualificam, registam e encaminham clientes — com opção de atendimento híbrido humano + IA.' },
    { q: 'A automatização funciona 24h?', a: 'Sim. Bots e fluxos automatizados podem operar continuamente, respeitando regras, limites de API e configurações do projeto.' },
    { q: 'Posso integrar com o meu sistema?', a: 'Sim. Integramos com ERPs, CRMs, painéis, bases de dados, APIs e webhooks conforme âmbito técnico definido.' },
    { q: 'Existe limite de utilização?', a: 'Sim. Limites dependem do plano, arquitetura e consumo de APIs externas. Projetos de alto volume exigem análise técnica e orçamento específico.' },
    { q: 'Oferecem suporte contínuo?', a: 'Sim. Oferecemos suporte, ajustes e evolução conforme plano contratado, incluindo acompanhamento da operação.' }
  ],

  finalCtaTitle: 'Pronto para automatizar a sua operação com inteligência artificial?',
  finalCtaSubtitle:
    'A WSJ cria soluções inteligentes para empresas que querem reduzir trabalho manual e melhorar atendimento, organização e escala.'
};

const enUS = {
  metaTitle: 'AI Automation | WSJ Soluções Digitais',
  badge: 'AI Automation',
  heroTitle: 'Intelligent AI automation for modern businesses.',
  heroSubtitle:
    'WSJ builds automated bots, intelligent assistants and AI-powered flows to reduce manual work and improve customer service.',
  heroBadges: [
    'ChatGPT',
    'Artificial Intelligence',
    'WhatsApp Bot',
    'Voice automation',
    'APIs',
    'Smart support',
    'Automated flows',
    'Integrated AI'
  ],
  btnQuote: 'Request a quote',
  btnWhatsapp: 'Talk on WhatsApp',
  btnPlans: 'View solutions',
  whatsappMessage: 'Hello! I would like a quote for AI automation with WSJ.',

  sectionProblemsTitle: 'Problems intelligent automation helps solve',
  sectionProblemsClose: 'Automation does not replace people. It reduces repetitive tasks and improves operations.',
  problemItems: [
    { title: 'Repetitive support', desc: 'Frequent questions that consume team time every day.' },
    { title: 'Slow responses', desc: 'Customers waiting while operations cannot keep up with volume.' },
    { title: 'Overloaded team', desc: 'Staff stuck on manual tasks instead of strategic focus.' },
    { title: 'Unanswered customers', desc: 'Lost messages, long queues and inconsistent experience.' },
    { title: 'Lack of organisation', desc: 'Scattered information without clear support or logging flow.' },
    { title: 'Limited support hours', desc: 'Business-hours-only operations while customers expect 24/7 answers.' },
    { title: 'Manual processes', desc: 'Orders, bookings and follow-ups done one by one, without scale.' },
    { title: 'Missed opportunities', desc: 'Leads and sales that go cold due to slow or missing responses.' }
  ],

  sectionSolutionsTitle: 'AI automation solutions',
  sectionSolutionsLead: 'From first automation to full intelligent operations — structured for your business.',
  solutions: [
    { title: 'WhatsApp bot', desc: 'Automated support on the channel your customers already use.' },
    { title: 'ChatGPT-integrated AI', desc: 'Smart replies connected to advanced language models.' },
    { title: 'Automated support', desc: 'Flows that respond, qualify and route according to rules.' },
    { title: 'Intelligent flows', desc: 'Automated journeys with context-based decisions.' },
    { title: 'Voice automation', desc: 'Voice assistants for support, triage and operations.' },
    { title: 'AI for booking', desc: 'Automated confirmations, reminders and schedule management.' },
    { title: 'AI for sales', desc: 'Lead qualification, catalogue and smart commercial guidance.' },
    { title: 'AI for support', desc: 'FAQ resolution, status updates and technical routing.' },
    { title: 'System integration', desc: 'Connection with ERP, CRM, dashboards and existing tools.' },
    { title: 'APIs & webhooks', desc: 'Real-time communication between systems and automations.' },
    { title: 'Admin dashboard', desc: 'Panel to track conversations, flows and operations.' },
    { title: 'Custom AI', desc: 'Assistant trained with your business context, rules and tone.' }
  ],

  sectionWhatsappTitle: 'Smart WhatsApp for support and operations',
  sectionWhatsappLead:
    'We automate support, lead capture and operations on WhatsApp with intelligent flows and integrated AI — aligned with your business reality.',
  whatsappFeatures: [
    'Automatic replies',
    'Support flows',
    'Integrated AI',
    'Lead capture',
    'Orders',
    'Bookings',
    'Catalogue',
    'Smart routing',
    'Hybrid human + AI support'
  ],
  whatsappNote:
    'WhatsApp integration may depend on official APIs, external providers and Meta policies.',

  sectionAiTitle: 'AI connected to your business',
  sectionAiLead:
    'We integrate artificial intelligence into your company context — with relevant answers, custom flows and system connections.',
  aiFeatures: [
    'ChatGPT integration',
    'Assistant trained with business context',
    'Text AI',
    'Voice AI',
    'Intelligent automation',
    'Contextual answers',
    'Custom flows',
    'Database integration',
    'Support history',
    'API-connected AI'
  ],
  aiNote:
    'AI services may generate monthly usage costs based on utilisation, tokens, API calls and external tools.',

  sectionCostsTitle: 'AI automation involves infrastructure and external services',
  sectionCostsLead:
    'WSJ works transparently so clients understand real operating costs before the project starts.',
  sectionCostsIntro:
    'AI automations are not unlimited by default. AI APIs, WhatsApp, servers, databases, voice and external integrations may generate monthly costs depending on volume and project complexity.',
  costItems: [
    { title: 'OpenAI / ChatGPT API', desc: 'Usage based on tokens, models used and interaction volume.' },
    { title: 'WhatsApp API', desc: 'Costs according to provider, message volume and Meta policies.' },
    { title: 'Servers', desc: 'Hosting, processing and infrastructure for flows and integrations.' },
    { title: 'Database', desc: 'Storage of history, context, orders and operational records.' },
    { title: 'Voice AI', desc: 'Synthesis, transcription and voice services may add usage costs.' },
    { title: 'External integrations', desc: 'Paid third-party tools connected to automation.' }
  ],
  costsHighlight:
    'WSJ works transparently so clients understand real operating costs before the project starts.',

  sectionProcessTitle: 'How the process works',
  sectionProcessLead: 'A clear path from idea to intelligent operations — with transparency at every stage.',
  processSteps: [
    { title: 'We understand your business flow', desc: 'We map support, processes, channels and real goals.' },
    { title: 'We define automations and integrations', desc: 'Scope, APIs, AI, external costs and solution architecture.' },
    { title: 'We build intelligent flows', desc: 'Bots, journeys, rules and support experience.' },
    { title: 'We integrate AI and APIs', desc: 'ChatGPT, WhatsApp, internal systems and external tools.' },
    { title: 'We test and monitor operations', desc: 'Validation, adjustments and support according to plan.' }
  ],

  sectionPlansTitle: 'AI automation plans',
  sectionPlansLead: 'From first bot to full intelligent operations — professional structure with transparency.',
  plansBillingMonthly: 'Monthly',
  plansBillingAnnual: 'Annual',
  plansSaveBadge: 'Save 17%',
  plansDisclaimer:
    'Prices do not include API usage, OpenAI, WhatsApp API, servers, external tools, storage, paid integrations or third-party charges.',
  plansDisclaimerExtra:
    'Projects with advanced AI, voice, high message volume, multiple channels, complex integrations or custom automations require technical analysis and a specific quote.',
  planStartName: 'AI Start',
  planStartDesc: 'Ideal for small automations and initial intelligent support.',
  planStartFeatures: [
    'Initial bot',
    'Automated flow',
    'Basic AI integration',
    'Basic WhatsApp automation',
    'Automatic replies',
    'Simple dashboard',
    'Basic support'
  ],
  planStartCta: 'Start automation',
  planGrowthName: 'AI Growth',
  planGrowthBadge: 'Most popular',
  planGrowthDesc: 'Ideal for businesses that want smarter, more integrated automation.',
  planGrowthFeatures: [
    'Everything in Start',
    'ChatGPT-integrated AI',
    'Advanced flows',
    'Intelligent support',
    'APIs',
    'Admin dashboard',
    'Support history',
    'Contextual AI',
    'External integrations',
    'Priority support'
  ],
  planGrowthCta: 'Get started',
  planPremiumName: 'AI Premium',
  planPremiumBadge: 'Premium',
  planPremiumDesc: 'Ideal for complex operations with AI, voice, multiple flows and advanced integrations.',
  planPremiumFeatures: [
    'Custom AI',
    'Advanced flows',
    'Voice automation',
    'Complex integrations',
    'Advanced APIs',
    'Scalable architecture',
    'Full dashboard',
    'Technical consulting',
    'Dedicated account manager',
    'Priority SLA'
  ],
  planPremiumCta: 'Talk to a specialist',

  sectionRealProjectsTitle: 'Experience applied to real digital solutions',
  sectionRealProjectsLead: 'WSJ already builds digital solutions and integrations used in real projects.',
  realProjectsNote:
    'WSJ experience in systems, e-commerce and automation enables intelligent flows integrated into client operations.',
  realProjectsVisitCta: 'View project',
  realProjectBadgeInstitutional: 'Corporate',
  realProjectBadgeEcommerce: 'E-commerce',
  realProjectBadgeProduct: 'WSJ Product',
  realProjects: [
    {
      name: 'WSJ Pedidos',
      url: '/wsj-pedidos',
      category: 'Automation & orders',
      badge: 'product',
      desc: 'Orders and digital support platform built by WSJ for real operations.',
      logo: '/wsj-logo.png',
      previewGradient: 'from-violet-600/30 via-indigo-900/15 to-slate-950/50'
    },
    {
      name: 'BENCOAÇO',
      url: 'https://bencoaco.com.br/',
      category: 'Digital presence',
      badge: 'institutional',
      desc: 'Professional digital project focused on authority, branding and online operation.',
      logo: '/assets/clients/bencoaco.png',
      previewGradient: 'from-blue-600/30 via-sky-900/15 to-slate-950/50'
    },
    {
      name: 'SOETO',
      url: 'https://www.soeto.com.br/',
      category: 'Digital operation',
      badge: 'ecommerce',
      desc: 'Complete digital structure with catalogue, user experience and professionalism.',
      logo: '/assets/clients/soeto.png',
      previewGradient: 'from-emerald-600/28 via-green-900/15 to-slate-950/50'
    },
    {
      name: 'CAFEGHINI',
      url: 'https://www.cafeghini.com.br/',
      category: 'Digital branding',
      badge: 'ecommerce',
      desc: 'Modern digital presence with premium visual identity and professional navigation.',
      logo: '/assets/clients/cafeghini.png',
      previewGradient: 'from-rose-600/30 via-red-900/15 to-slate-950/50'
    }
  ],

  sectionFaqTitle: 'FAQ',
  sectionFaqLead: 'Full transparency before you invest in AI automation.',
  faqItems: [
    { q: 'Does the AI use ChatGPT?', a: 'Yes. Depending on the project, we integrate OpenAI models (ChatGPT) and other AI APIs, always according to scope and proposal.' },
    { q: 'Is there a monthly OpenAI cost?', a: 'Yes. AI services like OpenAI charge based on usage, tokens and API calls. These costs are not included in plans unless stated in the proposal.' },
    { q: 'Is WhatsApp automation official?', a: 'It depends on project architecture. Integration may use official APIs or external providers, according to needs, volume and Meta policies.' },
    { q: 'Do you build voice automation?', a: 'Yes. We develop voice assistants and audio automations, especially in advanced plans or custom projects.' },
    { q: 'Can AI respond to customers automatically?', a: 'Yes. We build flows that respond, qualify, log and route customers — with optional hybrid human + AI support.' },
    { q: 'Does automation work 24/7?', a: 'Yes. Bots and automated flows can run continuously, respecting rules, API limits and project settings.' },
    { q: 'Can I integrate with my system?', a: 'Yes. We integrate with ERPs, CRMs, dashboards, databases, APIs and webhooks according to defined technical scope.' },
    { q: 'Is there a usage limit?', a: 'Yes. Limits depend on plan, architecture and external API consumption. High-volume projects require technical analysis and a specific quote.' },
    { q: 'Do you offer ongoing support?', a: 'Yes. We offer support, adjustments and evolution according to the contracted plan, including operation monitoring.' }
  ],

  finalCtaTitle: 'Ready to automate your operations with artificial intelligence?',
  finalCtaSubtitle:
    'WSJ builds intelligent solutions for businesses that want to reduce manual work and improve support, organisation and scale.',

  heroMock: {
    chatLabel: 'AI Chat',
    whatsappLabel: 'WhatsApp Bot',
    voiceLabel: 'Voice AI',
    analyticsLabel: 'Analytics',
    flowLabel: 'Automated flow',
    live: 'Active operation'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const automationPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
